<template>
    <div class="bg-gray-100">

            <!-- Header -->
            <div class="flex items-center p-4">
                <button
                    :class="$colors.primary"
                    class="rounded-full flex justify-center items-center w-9 h-9 mr-3"
                    @click="RouterBack()"
                >
                    <i class="material-icons">chevron_left</i>
                </button>
                <div class="text-lg md:text-xl font-semibold text-green-600">
                    {{$t('update_shipping')}}
                </div>
            </div>
            
            <!-- Card -->
            <div class="px-3 md:px-6 pb-6">

                <div class="bg-white w-full rounded-lg shadow">
                    <!-- Block title -->
                    <div class="flex items-center p-4 md:p-6 border-b">
                    <span class="rounded-full h-10 w-10 bg-gray-100 flex items-center justify-center">
                        <i class="material-icons text-green-500">local_mall</i>
                    </span>
                    <p class="ml-3 text-base md:text-lg font-semibold text-gray-700">
                        {{$t('shipping_informations')}}
                    </p>
                    </div>

                    <!-- Form -->
                    <div class="p-4 md:p-6">
                    <!-- grid: 1 col mobile / 2 cols md+ -->
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">

                         <!-- Status -->
                         <div>
                        <label class="block text-xs text-gray-700 mb-1">
                            {{$t('status')}} <span :class="$colors.required">*</span>
                        </label>
                        <select
                            v-model="formData.status"
                            @change="onChangeStatus($event)"
                            :disabled="(formData.status==='processed' || formData.status==='return' || formData.status==='rembourser')"
                            :style="colorStatus(formData.status)"
                            class="w-full text-sm capitalize border rounded px-2 py-2 bg-white focus:outline-none focus:ring-1 focus:ring-green-500"
                        >
                            <option class="bg-white" :value="null">{{$t('status')}}</option>
                            <option
                            class="bg-white text-gray-700"
                            v-for="(value, index) in statusShipping"
                            :key="index"
                            :value="value.value"
                            >
                            {{ value.label ? value.label : $t(value) }}
                            </option>
                        </select>
                        </div>

                        <div v-if="formData.status==='cancelled' || formData.status==='refused'">
                        <label class="block text-xs text-gray-700 mb-1">
                            {{$t('cancelatation_comment_shipping')}} <span :class="$colors.required">*</span>
                        </label>
                        <textarea
                            v-model="formData.notes"
                            class="w-full text-sm border rounded px-2 py-2 focus:outline-none focus:ring-1 focus:ring-green-500"
                        ></textarea>
                        </div>

                        <!-- Address -->
                        <div>
                        <label class="block text-xs text-gray-700 mb-1">
                            {{$t('address_shipping')}} <span :class="$colors.required">*</span>
                        </label>
                        <textarea
                            v-model="formData.address"
                            class="w-full text-sm border rounded px-2 py-2 focus:outline-none focus:ring-1 focus:ring-green-500"
                        ></textarea>
                        </div>

                        <!-- Date -->
                        <div>
                        <label class="block text-xs text-gray-700 mb-1">
                            {{$t('shipping_date')}} <span :class="$colors.required">*</span>
                        </label>
                        <input
                            type="date"
                            v-model="formData.date"
                            :min="today"
                            class="w-full text-sm border rounded px-2 py-2 focus:outline-none focus:ring-1 focus:ring-green-500"
                        />
                        </div>

                        <!-- Zone (non-MA) -->
                        <div v-if="formData.country && formData.country !== 'MA'">
                        <label class="block text-xs text-gray-700 mb-1">
                            {{$t('zone_shipping')}}
                        </label>
                        <v-select
                            class="w-full border rounded"
                            :class="{ disabled: currentUser.type=='Courier' }"
                            label="name"
                            v-model="formData.zone"
                            :options="zones"
                        />
                        </div>

                        <!-- Courier -->
                        <div>
                        <label class="block text-xs text-gray-700 mb-1">
                            {{$t('courier')}} <span :class="$colors.required">*</span>
                        </label>
                        <v-select
                            class="w-full border rounded"
                            :class="{ disabled: currentUser.type=='Courier' }"
                            label="fullName"
                            @search="searchCouriers($event,'hh')"
                            v-model="formData.courier"
                            :options="couriers"
                        />
                        </div>

                        <!-- City -->
                        <div>
                        <label class="block text-xs text-gray-700 mb-1">
                            {{$t('city')}} <span :class="$colors.required">*</span>
                        </label>
                        <v-select
                            class="w-full border rounded"
                            v-model="formData.order.customer.city"
                            :options="cities"
                            :disabled="['delivered','paid','processed'].includes(formData.status)"
                        />
                        </div>

                       

                        <!-- Comment order -->
                        <div class="md:col-span-2">
                        <label class="block text-xs text-gray-700 mb-1">
                            {{$t('comment_order')}}
                        </label>
                        <textarea
                            v-model="formData.order.comment"
                            class="w-full text-sm border rounded px-2 py-2 focus:outline-none focus:ring-1 focus:ring-green-500"
                        ></textarea>
                        </div>

                        <!-- Cancel/Refused note -->
                       
                    </div>

                    <!-- Save -->
                    <div class="pt-5">
                        <button
                        class="w-full md:w-40 rounded text-white px-4 py-2 bg-green-600 hover:bg-green-700 transition disabled:opacity-60"
                        :disabled="loading"
                        @click="save"
                        >
                        {{$t('save')}}
                        </button>
                    </div>
                    </div>
                </div>

                <!-- Products table (responsive) -->
                <div class="bg-white rounded-lg shadow mt-4">
                    <div class="flex items-center p-4">
                    <span class="rounded-full h-10 w-10 bg-gray-100 flex items-center justify-center">
                        <i class="material-icons text-green-400">local_mall</i>
                    </span>
                    <div class="ml-2 text-base font-semibold text-gray-700">
                        {{$t('products_order')}}
                    </div>
                    <button
                        v-if="formData.status!='processed' && ['Admin','CEO'].includes(currentUser.type)"
                        @click="ChangeQuantityOrder(formData)"
                        class="ml-auto bg-blue-700 text-white px-3 py-2 rounded text-sm"
                    >
                        Change quantity Or TotalPrice
                    </button>
                    </div>

                    <div class="px-4 pb-4 overflow-x-auto">
                    <!-- حد أدنى للعرض باش ما يتكرفصش الجدول فالتليفون -->
                    <table class="min-w-[640px] w-full leading-normal">
                        <thead>
                        <tr>
                            <th class="px-4 py-2 border-b text-left text-xs font-semibold text-gray-600">
                            {{$t('image')}}
                            </th>
                            <th class="px-4 py-2 border-b text-left text-xs font-semibold text-gray-600">
                            {{$t('product')}}
                            </th>
                            <th class="px-4 py-2 border-b text-left text-xs font-semibold text-gray-600">
                            {{$t('quantity')}}
                            </th>
                            <th class="px-4 py-2 border-b text-left text-xs font-semibold text-gray-600">
                            {{$t('price')}}
                            </th>
                        </tr>
                        </thead>
                        <tbody v-for="(it, index) in formData.order.details" :key="it._id">
                        <tr :class="index % 2 == 0 ? 'bg-gray-50' : ''">
                            <td class="px-4 py-2 border-b">
                            <img
                                :src="it.product.picture || 'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"
                                class="h-16 w-16 object-cover rounded-md"
                            />
                            </td>
                            <td class="px-4 py-2 border-b text-sm text-gray-800">
                            {{ it.product.name }}
                            </td>
                            <td class="px-4 py-2 border-b text-sm">
                            <span class="font-semibold">{{ it.quantity }}</span>
                            </td>
                            <td class="px-4 py-2 border-b text-sm">
                            <span class="font-semibold">{{ it.unitPrice }}</span>
                            <sup v-if="idWharhouse" class="uppercase">{{ idWharhouse.currency }}</sup>
                            </td>
                        </tr>
                        </tbody>
                        <tbody>
                        <tr>
                            <td colspan="5" class="px-4 py-2 text-right">
                            <div class="text-xs font-bold text-gray-900">
                                {{$t('total_price')}}: {{ formData.order.totalPrice }}
                                <sup v-if="idWharhouse" class="uppercase">{{ idWharhouse.currency }}</sup>
                            </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>

            </div>
        
         <!--*******************  Product returned ***************************************-->
         <span class="flex w-full px-6" :id="'return-'+formData._id">
            <div  v-if="formData.status=='return'" class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                <div class="flex w-full mt-1">
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                        <i class="material-icons p-3 text-green-400 ">local_mall</i>
                    </span>
                    <div class="ml-5 w-full pb-4">
                        <div class="text-base mt-1 font-semibold text-gray-600 pb-10">{{$t('products_returned')}}</div>
                        <div class="w-full space-y-4">
                            <div class="w-full">
                                <table class="min-w-full w-full">
                                    <thead class="text-white">
                                        <tr class="bg-green-400  flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                            <th class="p-2 justify-center">{{$t('image')}}</th>
                                            <th class="p-2 justify-center">{{$t('name')}}</th>
                                            <th class="p-2 justify-center">{{$t('quantity_sent')}}</th>
                                            <th class="p-2 justify-center">{{$t('quantity_returned')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="flex-1 sm:flex-none">
                                        <tr v-for="(it,index) in formData.order.details" :key="index" class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2">
                                                <div> <img :alt="it.product.name" :src="it.product.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'" class="h-16 w-16 rounded-md mx-auto" /> </div>
                                            </td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.product.name }}</b></td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                                                    <span>{{it.quantity}}</span>
                                            </td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                                                    <table class="min-w-full">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-green-500  tracking-wider">{{$t('ok_good')}}</th>
                                                            <th  v-if="CheckQteReturnedexist" class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-green-500  tracking-wider">{{$t('defective')}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="bg-white">
                                                        <tr>
                                                            <td class="px-6 py-4 border whitespace-no-wrap"><div class="flex items-center">
                                                                <input id="Defective" :disabled="CheckQteReturnedexist" type="number" :max="it.quantity" min="0"  v-model="it.product.qteChange" class="py-2 border-4 border-light-blue-500 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
                                                            </div>
                                                            </td>
                                                            <td  v-if="CheckQteReturnedexist" class="px-6 py-4 border whitespace-no-wrap"><div class="flex items-center"> {{ it.quantity-it.product.qteChange }}</div></td>    
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </span>
        <!--  end product returned -->    
          <!--*******************  Product change ***************************************-->
           <div  v-if="formData.type=='change'" class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                <div class="flex w-full mt-1">
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                        <i class="material-icons p-3 text-green-400 ">local_mall</i>
                    </span>
                    <div class="ml-5 w-full pb-4">
                        <div class="text-base mt-1 font-semibold text-gray-600 pb-10">{{$t('products_change')}}</div>
                        <div class="w-full space-y-4">
                            <div class="w-full">
                                <table class="min-w-full w-full">
                                    <thead class="text-white">
                                        <tr class="bg-green-400  flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                            <th class="p-2 justify-center">{{$t('image')}}</th>
                                            <th class="p-2 justify-center">{{$t('name')}}</th>
                                            <th class="p-2 justify-center">{{$t('quantity')}}</th>
                                            <th class="p-2 justify-center">{{$t('quantity_returned')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="flex-1 sm:flex-none">
                                        <tr v-for="(it,index) in formData.order.details" :key="index" class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2">
                                                <div> <img :alt="it.product.name" :src="it.product.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'" class="h-16 w-16 rounded-md mx-auto" /> </div>
                                            </td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.product.name }}</b></td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"><b>{{ it.quantity }}</b></td>
                                            <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                                                 <table class="min-w-full">
                                                   <thead>
                                                       <tr>
                                                         <th class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-green-500  tracking-wider">{{$t('ok_good')}}</th>
                                                         <th  v-if="CheckQteDefecteuseexist" class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-green-500  tracking-wider">{{$t('defective')}}</th>
                                                       </tr>
                                                    </thead>
                                                    <tbody class="bg-white">
                                                        <tr>
                                                          <td class="px-6 py-4 border whitespace-no-wrap"><div class="flex items-center">
                                                             <input id="Defective" :disabled="CheckQteDefecteuseexist" type="number" :max="it.quantity" min="0"  v-model="it.product.qteChange" class="py-2 border-4 border-light-blue-500 border-opacity-100  text-xs px-2 outline-none block h-full w-full" />
                                                          </div>
                                                          </td>
                                                           <td  v-if="CheckQteDefecteuseexist" class="px-6 py-4 border whitespace-no-wrap"><div class="flex items-center"> {{ it.quantity-it.product.qteChange }}</div></td>    
                                                       </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
           </div>
        <!--  end product change --> 

         

          <StatusTransitions />
          
     </div>
</template>
<script>
    export default {
        props: {
            currentUser: { type: Object},
            idWharhouse: { type: Object},
            sous_idWharhouse: { type: String},
            sous_warehouses: { type: Array},
        },
        data() {
            return {
                formData: {
                    order:{
                        customer: {},
                        seller:{}
                    }   
                },
                searchText: "",
                quantity: 0,
                couriers:[],
                status: [],
                products: [],
                show_modal: true,
                CheckQteReturnedexist:false,
                limit: 10,
                paginate: {
                    total: 0,
                    currentpage: 1,
                    lastpage: 1,
                    per_page: 0,
                },
                productselected: [],
                numberItemRepeated: 0,
                sellers: [],
                zones:[],
                courier :[],
                statusShipping: ["to prepare","outofstock", "prepared", "processed","shipped",'reprogrammer','delivered','paid','cancelled','refused','remind','unreachable','return'],
                typesShipp:[ "pendingchange", "change"],
                showMoreInfo:false,
                CheckQteDefecteuseexist:false,
                sellerExists:false,
                options: this.$countries,
                currentCurrency:"",
                cities: [],
                dataCountry: this.$countries,
                loading: false,
                today: new Date().toISOString().split('T')[0],
            };
        },
        watch: {
            'formData.date'(val) {
                // si user = Courier, on bloque les dates > today (ne peut pas choisir demain)
                if (this.currentUser.type === 'Courier' && val > this.today) {
                    this.formData.date = this.today;
                    this.$toast.warning("Le livreur ne peut choisir qu'une date du jour.");
                }
            }
        },
        async mounted() {
            console.log('idWharhouse---------',this.idWharhouse)
           
            await this.GetShipping();

            if (this.currentUser.type != "Seller") {
               // this.getSellers();
            }
           
           // await this.getProducts({});
            await this.getZones();
            await this.getCouriers();
            //await this.getCurrentCourierZone(this.formData.zone._id);
           // await this.CheckQteDefecteuse();
        },
        methods: {
            translatedOptions(sourceArray = []) {
                const _locale = this.$i18n.locale; // باش تكون reactivity مع تبديل اللغة
                if (!Array.isArray(sourceArray)) return [];

                // واش كل العناصر بسيطة (ماشي objects)؟
                const onlyPrimitives = sourceArray.every(
                    (item) => item === null || typeof item !== 'object'
                );

                if (onlyPrimitives) {
                    // كنحوّل strings/numbers إلى { value, label } مع ترجمة label
                    return sourceArray.map((item) => ({
                    value: item,
                    label: this.$t(String(item))
                    }));
                }

                // إلا كان فيه objects كنرجّع المصفوفة كما هي
                return sourceArray;
            },

             colorStatus(status) {
            switch (status) {
                case 'to prepare':
                    return "color: rgb(233 147 19); border-color: rgb(233 147 19);" 
                    break;
                 case 'outofstock':
                                    return "color: rgb(203 21 160); border-color: rgb(203 21 160);"
                                    break;
                case 'prepared':
                    return  "color:rgb(58 217 18); border-color: rgb(58 217 18);" 
                    break;
                case 'shipped':
                    return  "color:rgb(58 217 18); border-color: rgb(58 217 18);" 
                    break;
                case 'delivered':
                    return  "color:rgb(58 217 18); border-color: rgb(58 217 18);" 
                    break;
                case 'paid':
                    return  "color:rgb(58 217 18); border-color: rgb(58 220 18);" 
                    break;
                case 'cancelled':
                    return "color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);" 
                    break;
                case 'refused':
                    return "color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);" 
                    break;
                case 'remind':
                    return "color: rgb(227 129 210); border-color: rgb(227 129 210);"
                    sbreak;    
                case 'unreachable':
                    return "color: rgb(141 8 118); border-color: rgb(141 8 118);"
                    break;
                 case 'rembourser':
                            return "color: rgb(227 129 210); border-color: rgb(227 129 210);"
                            break;    
                case 'return':
                    return "color: rgb(141 8 118); border-color: rgb(141 8 118);"
                    break;    
    }
             },
              RouterBack: function() {
                this.$router.back();
            },
            async getCurrencyBycontry(country){
                const resW = await this.$server.get("warehouses", { country: country}); 
                this.currentCurrency=resW.content.currency;
                this.idWharhouse=resW.content._id;
            },
            TotalPrice(){
                let Total=0;
                    for (const element of this.formData.order.details) {
                        Total+=element.unitPrice * element.quantity;
                    }
                    return Total;
             },
             async CheckQteDefecteuse(){
                this.CheckQteDefecteuseexist=false;
                if(this.formData.type=='change' ){
                        for (let i in this.formData.order.details) {
                            const filters = {
                            product: this.formData.order.details[i].product._id,
                            order: this.formData.order._id,
                            shipping: this.formData._id,
                            };
                        const res = await this.$server.search("stockHistories", filters);
                        
                        if(typeof res.content.results !== 'undefined') {
                            this.formData.order.details[i].product.qteChange=res.content.results[0].quantity;
                            this.CheckQteDefecteuseexist=true;
                        }
                        }
                }    
            }, 
            async getCouriers(){
                const filter = {
                type: "Courier",
                countries:this.formData.country,
                limit:this.limit
              };
                const res = await this.$server.search("users", filter);
                if (res.content.results) this.couriers = res.content.results;
                else this.couriers = [];
            }, 
            searchCouriers: _.debounce(async function(search) {
                const filter = {
                    type: "Courier",
                    limit:this.limit,
                    countries:this.formData.country,
                    name: search,
                    };  
                    const res= await this.$server.find("users",filter);   
                if (res.content.results) this.couriers = res.content.results;
                else this.couriers = [];
            }, 500),
             async getCurrentCourierZone(id){
                const filter = {
                    type: 'Courier',
                    zones:id
                };
                const res = await this.$server.search("users",filter);
                if (res.content.results) {
                    this.courier = res.content.results;
                } else this.courier = [];
             }, 
              async getCourierZone(event){
                const filter = {
                    type: 'Courier',
                    zones:event.target.options[event.target.options.selectedIndex].id
                };
                const res = await this.$server.search("users",filter);
                if (res.content.results) {
                    this.courier = res.content.results;
                } else this.courier = [];
            },
             startConfirmation() {
                this.showMoreInfo =  !this.showMoreInfo ;
             },
            async getZones() {
                const resCities = await this.$server.get("zones", { allCities: true,country:this.formData.country}); 
                if(resCities && resCities.content.length>0)  this.cities= resCities.content;
                else this.cities=[];

                const res = await this.$server.search("zones",{limit:2000,country: this.formData.country});
                if (res && res.content.results) this.zones = res.content.results;
                else this.zones = [];
            },
            async getUser() {
                const res = await this.$server.me("users");
                //console.log(res);
                if (res.content) this.currentUser = res.content;
                else this.currentUser = {};
            },
            async getProducts(filters) {
                if (this.formData.order.seller) filters.seller = this.formData.order.seller._id;

                const res = await this.$server.search("products", filters);
                if (res.content.results) {
                    this.products = res.content.results;
                    this.paginate.total = res.content.total;
                    this.paginate.lastpage = res.content.last_page;
                    this.paginate.per_page = res.content.per_page;
                    this.paginate.currentpage = res.content.current_page;

                    for (let i in this.products) {
                        this.products[i].quantity = this.products[i].quantity.inStock;
                        /*if (this.products[i].category)
                          this.products[i].category = this.products[i].category.name;*/
                        if (this.products[i].seller)
                            this.products[i].seller = this.products[i].seller.username;
                    }
                } else this.products = [];
            },

            async getStatus() {
                const res = await this.$server.search("status");
                if (res.content.results) this.status = res.content.results;
                else this.status = [];
            },
            async save() {

                    if(['cancelled','refused'].includes(this.formData.status) && !this.formData.notes){
                        alert("Raison d'annulation obligatoir !", "warning");
                        return false;
                    }
                   // this.formData.order.seller = this.formData.order.seller;
                    this.$confirm(`Êtes-vous sûr de vouloir mettre à jour cet envoi (statut : ${this.formData.status}) ?`).then(async (res) => {
                         if (res) {
                            this.loading = true;
                            this.formData.order.shippingEdit=this.formData._id; 
                            const  dataorderedit = await this.$server.update('orders', _.pick(this.formData.order, ['_id', 'comment','customer','shippingEdit']));
                            delete  this.formData.order.shippingEdit;
                            delete  this.formData.orderObjet;
                            
                            const data = await this.$server.update("shippings", this.formData);
                            this.loading = false;
                            if (data && data._id) {
                                alert(this.$t('shippings_updated'), "success");
                                await this.GetShipping();
                            }else {this.loading = false;alert(data, "warning");await this.GetShipping();}
                         }   
                    });
                      
            },

            checkData() {
                if (this.formData.order.date && this.formData.order.details.length > 0 && this.formData.order.customer) return true;
                else return false;
            },

            removeProduct(data, index) {
                this.$confirm(this.$t('confirm_delete_product')).then(
                    async (res) => {
                        let pos = this.formData.order.details
                            .map(function (e) {
                                return e.product._id;
                            })
                            .indexOf(data._id);

                        this.formData.order.details.splice(pos, 1);
                        data.product.check = false;
                        alert(this.$t('product_deleted'), "success");
                    }
                );
            },

            addProductsToTemp(data, index) {
                if (data.check) {
                    const detail = {
                        product: data,
                        unitPrice: 1,
                        category: data.category._id,
                        quantity: 1,
                    };

                    let found = 0;
                    for (let i = 0; i < this.formData.order.details.length; i++) {
                        if (this.formData.order.details[i].product._id == data._id) {
                            found = found + 1;
                            this.numberItemRepeated = this.numberItemRepeated + 1;
                        }
                    }
                    if (found >= 1) {
                    } else {
                        this.productselected.push(detail);
                    }
                } else {
                    let pos = this.productselected
                        .map(function (e) {
                            return e.product._id;
                        })
                        .indexOf(data._id);
                    this.productselected.splice(pos, 1);
                }
            },

            addQuantity(index) {
                this.formData.order.details[index].quantity++;
            },
            removeQuantity(index) {
                if (this.formData.order.details[index].quantity <= 1) {
                } else {
                    this.formData.order.details[index].quantity--;
                }
            },
            ViderTable() {
                //console.log("HI SOUKA");
                this.productselected = [];
            },
            async getElementInArray(data,value){
                if(value){
                var result  = data.filter(function(o){
                        let whar=o.warehouse;
                        if(o.warehouse._id) whar=o.warehouse._id;
                        return whar == value.toString();
                    } );
                    return result? result[0] : null; // or undefined
                }else  return null;
                
            },
            async GetShipping() {
                if (this.$route.params.id) {
                    this.loading = true;
                    const editData = await this.$server.get("shippings", {id: this.$route.params.id,});
                    this.loading = false;

                    this.formData = editData.content;
                    this.formData.order.date = this.$moment(this.formData.order.date).format('yyyy-MM-DDTHH:mm');
                    this.formData.date = this.$moment(this.formData.date).format('yyyy-MM-DD');
                    
                    let dataWhrahouseSetting=null;
                    if(this.formData.seller.settings && this.formData.seller.settings.length>0) dataWhrahouseSetting=await this.getElementInArray(this.formData.seller.settings,this.idWharhouse._id);
                    if(this.currentUser.type=="StockManager") this.statusShipping=["to prepare","outofstock","prepared",'region in progress','return callcenter','refused','cancelled','return']
                    if(this.currentUser.type=="Courier") this.statusShipping=["prepared",'shipped','region in progress',"delivered",'refused','cancelled']
                    if(this.currentUser.type=="Accountant") this.statusShipping=["delivered",'paid']
                    if(this.currentUser.type == "Return") this.statusShipping=["cancelled","refused","return",'shipped']
                    this.statusShipping = this.translatedOptions(this.statusShipping);

                     await this.chechQteReturned();
                     
                }
            },
            scrollTo(hash) {
                location.hash = "#" + hash;
            },
            async onChangeStatus(event){
                if(event.target.value === 'return'){
                    await this.chechQteReturned();
                    this.scrollTo(this.formData._id);
               }
            },
            async chechQteReturned(){
                if(this.formData.status=='return'){
                        for (let i in this.formData.order.details) {
                            const filters = {
                                product: this.formData.order.details[i].product._id,
                                order: this.formData.order._id,
                                shipping: this.formData._id,
                            };
                        const res = await this.$server.search("stockHistories", filters);
                        
                        if(typeof res.content.results !== 'undefined') {
                            this.formData.order.details[i].product.qteChange=res.content.results[0].quantity;
                            this.CheckQteReturnedexist=true;
                        }
                        }
                   }  
            },
            async getSellers() {
                const filter = {
                    type: "Seller"
                };
                const res = await this.$server.search("users", filter);
                if (res.content.results) {this.sellers = res.content.results;this.sellerExists=true;}
                else this.sellers = [];
            },
            searchSellers: _.debounce(async function(search,event) {
                const filter = {
                    type: "Seller",
                    limi:this.limit,
                    name: search,
                };
                const res= await this.$server.find("users",filter);

                if (res.content.results) {this.sellers = res.content.results;}
                else this.sellers = [];
           }, 500),
        },

        computed: {
            isCourier() {
                return this.currentUser.type === 'Courier';
            },
            minDate() {
                // si Courier → min = max = today (il peut choisir que aujourd’hui)
                return this.isCourier ? this.today : this.today;
            },
            maxDate() {
                return this.isCourier ? this.today : null; // null = pas de limite
            },
            formattedDate() {
                return this.$moment(this.formData.date).format('yyyy-MM-DD');
            }, 
            formattedDateShipp() {
                return this.$moment(this.formData.date).format('yyyy-MM-DD');
            },     
            resultSearchUsers() {
                if (this.searchText) {
                    return this.products.filter((product) => {
                        var regex = new RegExp(this.searchText, "i");

                        return regex.test(product.name);
                    });
                } else {
                    return this.products;
                }
            },
        },

        /************************************* Pagination **************************************************/
    };
</script>

<style scoped>
.tab-cc{
    margin-bottom: 40px;
    margin-top: 10px;
}
.h-30{
    height: 30px;
}
svg {
  display: inline-block;
  vertical-align: middle;
}
    .btn-more i{
        display: block;
    }
    .toggle__dot {
        transition: all 0.3s ease-in-out;
    }
.disabled {
      pointer-events:none;
      color: #bfcbd9;
      cursor: not-allowed;
      background-image: none;
      background-color: #eef1f6;
      border-color: #d1dbe5;   
    }
    input:checked~.toggle__dot {
        transform: translateX(100%);
        background-color: #68d391;
    }

    /* animation for vue transition tag */
    dialog[open] {
        animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
    }

    dialog::backdrop {
        background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
        backdrop-filter: blur(3px);
    }

    @keyframes appear {
        from {
            opacity: 0;
            transform: translateX(-3rem);
        }

        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
</style>